// SharedComponents/BreadCrumb.jsx
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import useBreadcrumbStore from "./breadcrumbStore";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const [isMobile, setIsMobile] = useState(false);

  const { placeName, categoryName, planName, isPageLoading } = useBreadcrumbStore();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hiddenPaths = ["/", "/login", "/signUp", "/about"];
  const isPlaceDetailPage = pathnames[0] === 'places' && pathnames.length === 2;
  const isPlanDetailPage = pathnames[0] === 'plans' && pathnames.length === 2;
  const isCityPage = pathnames[0] === "places" && pathnames[1] === "city" && pathnames.length === 3;

if (isCityPage) return null;
  if (isPageLoading || hiddenPaths.includes(location.pathname)) {
    return null;
  }

  const nameMap = {
    plans: "برنامه‌ها",
    "search-results": "نتایج جستجو",
    signUp: "ثبت‌نام",
    login: "ورود",
    about: "درباره ما",
    userProfile: "پروفایل کاربر",
    city:            "شهرها",
    destinations: "شهرها"
  };

  let displayPathnames = isMobile ? pathnames.slice(-2) : pathnames;

  const breadcrumbItems = displayPathnames.filter((name) => {
    if (name === 'places') return false;
    if ((isPlaceDetailPage || isPlanDetailPage) && name === displayPathnames[displayPathnames.length - 1]) return false;
    if (name === 'category') return false;
    return true;
  });

  return (
    <nav className="text-sm text-gray-700 px-[16px] tablet:px-20 desktop:px-36 pt-20 font-myYekanFaNumRegular pb-2">
      <ol className="flex flex-wrap items-center space-x-1 space-x-reverse">
        <li>
          <Link to="/" className="text-black-600 hover:underline">خانه</Link>
        </li>

        {breadcrumbItems.map((name, index) => {
          const isLast = index === breadcrumbItems.length - 1;
          const displayName = nameMap[name] || decodeURIComponent(name);
          
          // ساخت مسیر صحیح برای آیتم فعلی
          let routeTo = "/";
          for (let i = 0; i <= index; i++) {
            routeTo += breadcrumbItems[i] + "/";
          }
          routeTo = routeTo.slice(0, -1);

          // تعیین اینکه آیا آیتم باید غیرقابل کلیک باشد
          // فقط آخرین آیتم در صفحات جزئیات باید غیرقابل کلیک باشد
          const shouldBeNonClickable = isLast && (isPlaceDetailPage || isPlanDetailPage);
          
          // استثنا: اگر name برابر با 'plans' باشد، حتی اگر آخرین آیتم باشد باید کلیک‌پذیر بماند
          const isPlansItem = name === 'plans';
          const isClickable = !shouldBeNonClickable || isPlansItem;

          return (
            <li key={name} className="flex items-center space-x-1 space-x-reverse">
              <span className="text-gray-400">&raquo;</span>
              {isClickable ? (
                <Link to={routeTo} className="text-black-600 hover:underline">
                  {displayName}
                </Link>
              ) : (
                <span className="font-semibold text-gray-900">{displayName}</span>
              )}
            </li>
          );
        })}

        {/* آیتم‌های اضافی برای صفحات جزئیات */}
        {isPlaceDetailPage && categoryName && (
          <li className="flex items-center space-x-1 space-x-reverse">
            <span className="text-gray-400">&raquo;</span>
            <Link to={`/places/category/${encodeURIComponent(categoryName)}`} className="text-gray-600 hover:underline">
              {categoryName}
            </Link>
          </li>
        )}
        
        {isPlaceDetailPage && placeName && (
          <li className="flex items-center space-x-1 space-x-reverse">
            <span className="text-gray-400">&raquo;</span>
            <span className="font-semibold text-gray-900">{placeName}</span>
          </li>
        )}

        {isPlanDetailPage && planName && (
          <li className="flex items-center space-x-1 space-x-reverse">
            <span className="text-gray-400">&raquo;</span>
            <span className="font-semibold text-gray-900">{planName}</span>
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;